export default defineNuxtRouteMiddleware((to) => {
  const appConfig = useRuntimeConfig().public;
  const skipAuthPagesForIFA = appConfig.APP_CUSTOMER.app_config.enable_skip_login_page_for_ifa_sso && appConfig.APP_FLAGS.hasIfaAuth;

  if (skipAuthPagesForIFA) {
    if (to.path === "/auth/login/")
      return navigateTo({ path: "/" });
  }
});
